export default __webpack_public_path__ + "static/media/cross1.ea5c2f03.png";